import { types } from "mobx-state-tree";
import { UserStore as User } from "./UserStore";

export const CourseStore = types
  .model({
    id: types.identifierNumber,
    name: types.maybeNull(types.string),

    author: types.maybeNull(User),
    price: types.optional(types.integer, 0),
    discount: types.maybeNull(
      types.model({
        type: types.enumeration(["percentage", "fixed"], "percentage"),
        value: types.maybeNull(types.integer),
      }),
    ),
  })
  .views((self) => ({
    discountPrice() {
      if (self.discount) {
        switch (self.discount.type) {
          case "fixed":
            return self.price - self.discount.value;
          case "percentage":
            return (self.price * (100 - self.discount.value)) / 100;
        }
      }
      return self.price;
    },
  }));
